document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('sfinger-site')) return;
  var bundle = window.SFINGER_I18N;
  if (!bundle) return;
  var languages = bundle.languages;
  var allowed = languages.map(function (item) { return item.code; });
  var language = 'en';
  try { var stored = localStorage.getItem('sfinger-language'); if (allowed.includes(stored)) language = stored; } catch (error) {}
  var picker = document.querySelector('[data-sf-language-picker]');
  var toggle = document.querySelector('[data-sf-language-toggle]');
  var choices = document.querySelector('[data-sf-language-options]');
  var selector = document.querySelector('[data-sf-variant]');
  var addButton = document.querySelector('[data-sf-add]');
  var addLabel = document.querySelector('[data-sf-add-label]');
  var originalTitle = document.title;
  var policyBody = document.querySelector('.sf-policy-body');
  if (policyBody) {
    var headings = Array.from(policyBody.querySelectorAll('h2,h3'));
    if (headings.length > 3) {
      var contents = document.createElement('details');
      contents.className = 'sf-policy-contents';
      contents.open = window.matchMedia('(min-width: 701px)').matches;
      var contentsTitle = document.createElement('summary');
      contentsTitle.textContent = 'On this page';
      contents.appendChild(contentsTitle);
      var contentsNav = document.createElement('nav');
      contentsNav.setAttribute('aria-label','On this page');
      headings.forEach(function (heading, i) {
        heading.id = 'sf-policy-section-' + i;
        var entry = document.createElement('a');
        entry.href = '#' + heading.id;
        entry.textContent = heading.textContent;
        contentsNav.appendChild(entry);
      });
      contents.appendChild(contentsNav);
      policyBody.before(contents);
    }
  }
  var canonical = {};
  var normalized = {};
  function normalize(value) { return value.trim().replace(/\s+/g, ' '); }
  Object.keys(bundle.texts).forEach(function (code) {
    normalized[code] = {};
    Object.keys(bundle.texts[code]).forEach(function (key) {
      normalized[code][normalize(key)] = bundle.texts[code][key];
      canonical[normalize(bundle.texts[code][key])] = key;
    });
  });
  function english(value) { var clean=normalize(value); var key=Object.prototype.hasOwnProperty.call(bundle.texts.en,clean) ? clean : canonical[clean];return key?value.replace(value.trim(),key):value; }
  function translate(text) {
    var trimmed=text.trim(), key=normalize(english(trimmed));
    var dictionary=normalized[language];
    if (dictionary[key]) return text.replace(trimmed,dictionary[key]);
    var phrase=key.replace(/\s*↗$/, '');
    if (dictionary[phrase]) return text.replace(trimmed,dictionary[phrase]+(key.endsWith('↗')?' ↗':''));
    return text.replace(/^Cart \(/,dictionary.Cart+' (')
      .replace(/ tracking points/g,' '+dictionary['tracking points'])
      .replace(/ points/g,' '+dictionary.points)
      .replace(/ each/g,' '+dictionary.each)
      .replace(/^From /,dictionary.From+' ')
      .replace(/^Concept rendering of /,dictionary['Concept rendering of']+' ')
      .replace(/^Quantity for /,dictionary.Quantity+' · ')
      .replace(/^Remove /,dictionary.Remove+' · ');
  }
  var savedNodes=[],savedAttributes=[];
  var excluded='script,style,[data-sf-language-picker],[data-sf-price],[data-sf-add-label],[data-sf-motion-label],[data-sf-react-root],[data-sf-language-content="zh"],.sf-policy-original-body';
  var walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT),node;
  while ((node=walker.nextNode())) {
    var parent=node.parentElement;
    if (!parent || !parent.closest('header.sf-header,main#MainContent,footer.sf-footer,.skip-to-content-link,.skip-link') || parent.closest(excluded)) continue;
    if (node.textContent.trim()) savedNodes.push({node:node,text:english(node.textContent)});
  }
  document.querySelectorAll('.sf-header [aria-label],.sf-footer [aria-label],#MainContent [aria-label],#MainContent [alt],#MainContent [placeholder],.skip-to-content-link,.skip-link').forEach(function (el) {
    if (el.closest(excluded)) return;
    ['aria-label','alt','placeholder'].forEach(function (name) { if (el.hasAttribute(name)) savedAttributes.push({element:el,name:name,text:english(el.getAttribute(name))}); });
  });
  function updateVariant() {
    var choice=selector && selector.options[selector.selectedIndex];
    if (choice) {
      document.querySelectorAll('[data-sf-price]').forEach(function (label) { label.textContent=choice.getAttribute('data-price'); });
      if (addButton) addButton.disabled=choice.getAttribute('data-available')!=='true';
    }
    if (addLabel && addButton) addLabel.textContent=translate(addButton.disabled?'Currently unavailable':'Add to cart');
  }
  function closeLanguage() { if (toggle) toggle.setAttribute('aria-expanded','false'); if (choices) choices.hidden=true; }
  function applyLanguage() {
    var selected=languages.find(function (item) { return item.code===language; });
    document.body.setAttribute('data-sf-language',language);
    document.documentElement.lang=selected.html;
    savedNodes.forEach(function (entry) { entry.node.textContent=translate(entry.text); });
    savedAttributes.forEach(function (entry) { entry.element.setAttribute(entry.name,translate(entry.text)); });
    if (toggle) {
      toggle.querySelector('[data-sf-language-current]').textContent=selected.flag+' '+selected.short;
      toggle.setAttribute('aria-label',translate('Select language')+': '+selected.name);
    }
    if (choices) choices.setAttribute('aria-label',translate('Select language'));
    if (choices) choices.querySelectorAll('[data-sf-language-choice]').forEach(function (button) { button.setAttribute('aria-selected',String(button.dataset.sfLanguageChoice===language)); });
    document.title=language==='en'?originalTitle:translate(originalTitle.split(' – ')[0])+' – SFINGER';
    updateVariant();updateMotionLabel();
    window.dispatchEvent(new CustomEvent('sfinger:language',{detail:language}));
  }
  if (toggle && choices) {
    toggle.addEventListener('click',function () { var open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));choices.hidden=!open; });
    toggle.addEventListener('keydown',function (event) { if (event.key==='ArrowDown') { event.preventDefault();toggle.setAttribute('aria-expanded','true');choices.hidden=false;choices.querySelector('[aria-selected="true"]').focus(); } });
    choices.addEventListener('click',function (event) { var button=event.target.closest('[data-sf-language-choice]');if (!button) return;language=button.dataset.sfLanguageChoice;try { localStorage.setItem('sfinger-language',language); } catch (error) {}applyLanguage();closeLanguage();toggle.focus(); });
    picker.addEventListener('keydown',function (event) {
      var buttons=Array.from(choices.querySelectorAll('button'));var i=buttons.indexOf(document.activeElement);
      if (event.key==='Escape') { event.stopPropagation();closeLanguage();toggle.focus(); }
      if (i>=0 && ['ArrowDown','ArrowUp','Home','End'].includes(event.key)) { event.preventDefault();buttons[event.key==='Home'?0:event.key==='End'?buttons.length-1:(i+(event.key==='ArrowDown'?1:-1)+buttons.length)%buttons.length].focus(); }
    });
    document.addEventListener('click',function (event) { if (!picker.contains(event.target)) closeLanguage(); });
    picker.addEventListener('focusout',function (event) { if (!picker.contains(event.relatedTarget)) closeLanguage(); });
  }
  if (selector) selector.addEventListener('change',function () { updateVariant();var url=new URL(window.location.href);url.searchParams.set('variant',selector.value);window.history.replaceState({},'',url); });
  var menuButton = document.querySelector('[data-sf-menu]');
  var menu = document.querySelector('#SfNavigation');
  function closeMenu() { if (menuButton) menuButton.setAttribute('aria-expanded','false'); document.body.classList.remove('sf-menu-open'); }
  if (menuButton) menuButton.addEventListener('click', function () {
    var open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded',String(open));
    document.body.classList.toggle('sf-menu-open',open);
  });
  if (menu) menu.querySelectorAll('a').forEach(function (link) { link.addEventListener('click',closeMenu); });
  document.addEventListener('keydown',function (event) { if (event.key === 'Escape') { closeMenu(); if (menuButton && menuButton.offsetParent) menuButton.focus(); } });
  var motionButton = document.querySelector('[data-sf-motion]');
  var motionPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function updateMotionLabel() {
    if (!motionButton) return;
    var key = motionPaused ? 'Play animation' : 'Pause animation';
    motionButton.querySelector('[data-sf-motion-label]').textContent = translate(key);
    motionButton.setAttribute('aria-pressed',String(motionPaused));
    document.body.classList.toggle('sf-motion-paused',motionPaused);
  }
  if (motionButton) motionButton.addEventListener('click',function () { motionPaused = !motionPaused; updateMotionLabel(); });
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('sf-in-view'); observer.unobserve(entry.target); } }); }, {threshold:0.08});
    document.querySelectorAll('[data-sf-reveal]').forEach(function (element) { element.classList.add('sf-will-reveal'); observer.observe(element); });
  }

  applyLanguage();
  var legacy = window.location.hash.replace(/^#\/?/,'');
  var legacyProducts = {'product/g1':'sfinger-g1','product/g1-pro':'sfinger-g1-pro','product/t1':'sfinger-t1'};
  if (legacyProducts[legacy]) window.location.replace('/products/'+legacyProducts[legacy]);
  else if (legacy === 'cart') window.location.replace('/cart');
  else if (legacy === 'products') window.location.replace('/#sf-products');
});
